/**
 * Adds transparency to a color
 * @param color - The color to add transparency to (hex, rgb, or rgba)
 * @param alpha - The transparency value between 0 and 1
 * @returns The color with transparency
 */
export const addTransparency = (color: string, alpha: number): string => {
  // Handle hex colors
  if (color.startsWith('#')) {
    const r = parseInt(color.slice(1, 3), 16);
    const g = parseInt(color.slice(3, 5), 16);
    const b = parseInt(color.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  // Handle rgb colors
  if (color.startsWith('rgb(')) {
    return color.replace('rgb', 'rgba').replace(')', `, ${alpha})`);
  }

  // Handle rgba colors
  if (color.startsWith('rgba(')) {
    return color.replace(/[\d.]+\)$/, `${alpha})`);
  }

  // Return original color if format is not recognized
  return color;
};
